import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Cache } from "aws-amplify";
import { Row, Col, Table, Button, Form } from "react-bootstrap";
import {
  fetchHolidays,
  deleteHoliday,
  filterHolidays,
  SET_HOLIDAYS_PAGINATION,
  RESET_HOLIDAYS_PAGINATION,
} from "../../../store/actions/holidays/holidaysActions";
import {
  PORTAL_ADMIN,
  PROJECT_ADMIN,
} from "../../../store/actions/users/usersActions";
import {
  togglePrompt,
  resetPagination,
} from "../../../store/actions/commonActions";
import { formatDate, ConfirmDialog } from "../../../common/Utilities";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

import ListPagination from "../../../common/ListPagination";
import PageTitle from "../../../common/PageTitle";

class Holidays extends Component {
  constructor(props) {
    super(props);
    this.holiday = {};
  }

  componentDidMount() {
    const roleId = Cache.getItem("roleId");
    if (roleId === PORTAL_ADMIN || roleId === PROJECT_ADMIN) {
      this.props.resetPagination(RESET_HOLIDAYS_PAGINATION);
      this.props.fetchHolidays();
    } else {
      this.props.history.push("/dashboard");
    }
  }

  promptModal = () => {
    let modalTitle = "";
    let modalBody = "";

    modalTitle = "Delete Holiday - " + this.holiday.name;
    modalBody = "Are you sure you want to delete this holiday?";

    const onHideFunction = () => {
      this.props.togglePrompt(false);
    };

    const onClickCancel = () => {
      this.props.togglePrompt(false);
    };

    const onClickConfirm = () => {
      this.props.deleteHoliday(this.holiday.id);
      this.props.togglePrompt(false);
    };

    return (
      <ConfirmDialog
        show={this.props.common.togglePrompt}
        modalTitle={modalTitle}
        modalBody={modalBody}
        onHideFunction={onHideFunction}
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm}
      />
    );
  };

  filterHolidays = () => {
    return (
      <Form.Control
        size="xl"
        type="search"
        placeholder="Filter Holidays"
        onChange={(e) => {
          const filter = e.target.value;
          this.props.filterHolidays(filter);
        }}
      />
    );
  };

  getFilteredHolidays = (holidays) => {
    if (!holidays) {
      return null;
    }

    return holidays.filter((holiday) => {
      const holidayName = holiday.name || "";
      const holidayDate = holiday.date || "";

      const holidayData = [holidayName, holidayDate].join(" ").toLowerCase();

      const holidayFilter = this.props.holidays.holidayFilter;

      if (!holidayFilter || holidayData.includes(holidayFilter.toLowerCase())) {
        return holiday;
      }
      return null;
    });
  };

  renderHolidays = () => {
    let holidays = this.getFilteredHolidays(this.props.holidays.holidays);

    if (holidays) {
      //if the user tries to search and no matches the filter
      if (this.props.holidays.holidayFilter && !holidays.length) {
        holidays = null;
      } else {
        let min = this.props.holidays.min;
        let max = this.props.holidays.max;

        if (!this.props.holidays.holidayFilter) {
          holidays = holidays.slice(min - 1, max);
        }
      }
    }

    let holidaysList = [];

    if (holidays) {
      holidaysList = holidays.length ? (
        holidays.map((holiday, key) => {
          return (
            <tr key={key}>
              <td>{holiday.name}</td>
              <td className="align-center">
                {formatDate(new Date(holiday.date), "/")}
              </td>
              <td className="float-right tbl-funcs tbl-funcs-impo align-items-center">
                <Button
                  className="btn-primary"
                  size="sm"
                  onClick={() => {
                    this.props.history.push(
                      "/settings/holidays/update?id=" + holiday.id
                    );
                  }}
                >
                  <FontAwesomeIcon icon={faPen} /> Edit
                </Button>
                <FontAwesomeIcon
                  icon={faTrash}
                  onClick={() => {
                    this.holiday = holiday;
                    this.props.togglePrompt(true);
                  }}
                  className="mx-1 hover-pointer"
                />
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={3}>Loading...</td>
        </tr>
      );
    } else {
      holidaysList = (
        <tr>
          <td colSpan={3}>
            <p className="text-danger">No holidays found.</p>
          </td>
        </tr>
      );
    }

    return holidaysList;
  };

  render() {
    const holidays = this.props.holidays.holidays;
    const addHoliday = (
      <Button
        id="add-holiday"
        size="sm"
        onClick={() => {
          this.props.history.push("/settings/holidays/add");
        }}
      >
        Add Holiday
      </Button>
    );

    let listPagination = "";

    if (!this.props.holidays.holidayFilter && holidays) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination
            dispatchType={SET_HOLIDAYS_PAGINATION}
            data={this.props.holidays.holidays}
            min={this.props.holidays.min}
            max={this.props.holidays.max}
            currentPage={this.props.holidays.currentPage}
            totalPages={this.props.holidays.totalPages}
            fetchCallback=""
            numItems={this.props.holidays.numItems}
          />
        </div>
      );
    }

    return (
      <>
        {this.promptModal()}
        <PageTitle pageName="Holidays" actionButton={addHoliday} />
        <Row>
          <Col>{listPagination}</Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table>
              <thead>
                <tr>
                  <th className="align-center">Holiday</th>
                  <th className="align-center">Date</th>
                  <th className="align-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={3}>{this.filterHolidays()}</td>
                </tr>
                {this.renderHolidays()}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>{listPagination}</Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  holidays: state.holidays,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => ({
  fetchHolidays: () => dispatch(fetchHolidays()),
  deleteHoliday: (...args) => dispatch(deleteHoliday(...args)),
  togglePrompt: (...args) => dispatch(togglePrompt(...args)),
  filterHolidays: (...args) => dispatch(filterHolidays(...args)),
  resetPagination: (...args) => dispatch(resetPagination(...args)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Holidays)
);
